module.exports = {
    "puzzleScreen": {
        "gameClass": "puzzle-screen",
        "questions_json_path": "./config/questions/puzzle-screen-questions/questions.json",
        "components": {
            "leaderboard": "triangle",
        },
        "screens": {
            "landingScreen": {
                "squiggle_colour": "tint2",
                "ball_colour": "red",
                "display_leaderboard_button": false,
                "display_start_button": true,
                "start_link_path": "/introduction",
                "icon": "critical-thinking",
            },
            "puzzleScreen": {
                "default_main_image": "./img/default-main-image.png",
            }
        }
    },
    "trackTheBall": {
        "gameClass": "track-the-ball",
        "components": {
            "leaderboard": "score",
        },
        "screens": {
            "landingScreen": {
                "squiggle_colour": "red",
                "ball_colour": "red",
                "display_leaderboard_button": true,
                "display_start_button": true,
                "start_link_path": "/introduction",
                "icon": "critical-thinking",
            },
            "leaderboardScreen": {
                "icon": "critical-thinking",
            }
        }
    },
    "sensors": {
        "gameClass": "sensors",
        "questions_json_path": "./config/questions/sensors-questions/questions.json",
        "components": {
            "leaderboard": "average",
        },
        "screens": {
            "landingScreen": {
                "squiggle_colour": "blue",
                "display_leaderboard_button": false,
                "display_start_button": true,
                "start_link_path": "/introduction",
                "icon": "critical-thinking",
            },
            "sensorsScreen": {
                "default_main_image": "./img/default-main-image.png",
            },
            "leaderboardScreen": {
                "icon": "critical-thinking",
            }
        }
    },
    "feedstock": {
        "gameClass": "feedstock",
        "questions_json_path": "./config/questions/feedstock-questions/questions.json",
        "components": {
            "leaderboard": "average",
        },
        "screens": {
            "landingScreen": {
                "squiggle_colour": "green",
                "display_leaderboard_button": false,
                "display_start_button": true,
                "start_link_path": "/executables/feedstock/attractor",
                "icon": "critical-thinking",
            },
            "sensorsScreen": {
                "default_main_image": "./img/default-main-image.png",
            },
            "leaderboardScreen": {
                "icon": "critical-thinking",
            }
        }
    },
    "teamSnake": {
        "gameClass": "team-snake",
        "components": {
            "leaderboard": "score",
        },
        "screens": {
            "landingScreen": {
                "squiggle_colour": "red",
                "display_leaderboard_button": false,
                "display_start_button": false,
                "start_link_path": "/introduction",
                "icon": "collaboration",
            },
            "leaderboardScreen": {
                "icon": "collaboration",
            }
        }
    },
    "satelliteImages": {
        "gameClass": "satellite-images",
        "components": {},
        "screens": {
            "landingScreen": {
                "squiggle_colour": "green",
                "display_leaderboard_button": false,
                "display_start_button": true,
                "start_link_path": "/executables/satellite-images/attractor",
                "icon": "communication",
            }
        },
        "hotspots_json_path": "./config/satellite-images/hotspots.json"
    },
    "fixTheMachine": {
        "gameClass": "fix-the-machine",
        "components": {},
        "screens": {
            "landingScreen": {
                "squiggle_colour": "white",
                "display_leaderboard_button": false,
                "display_start_button": false,
                "start_link_path": "/introduction",
                "icon": "critical-thinking",
            }
        }
    }
};
